export const LosslessFormat = {
  Exr: 'exr',
  Png: 'png',
};

export const LosslessFormatNames = {
  [LosslessFormat.Exr]: 'exr',
  [LosslessFormat.Png]: 'png',
};

export const LosslessFormatOptions = Object.entries(LosslessFormatNames)
  .map(([value, label]) => ({ value, label }));
